import ButtonStateService from "@core-ui/ContextServices/ButtonStateService/ButtonStateService";
import Workspace from "@core-ui/ContextServices/Workspace";
import t from "@ext/localization/locale/translate";
import type { Editor } from "@tiptap/core";
import { DropdownMenuRadioGroup, DropdownMenuRadioItem } from "@ui-kit/Dropdown";
import { Icon } from "@ui-kit/Icon";

interface QuestionMenuButtonProps {
	editor: Editor;
}

const QuestionMenuButton = ({ editor }: QuestionMenuButtonProps) => {
	const workspace = Workspace.current();
	if (!workspace?.enterprise?.gesUrl || !workspace?.enterprise?.modules?.quiz) return null;
	const { disabled, isActive } = ButtonStateService.useCurrentAction({ action: "question" });

	return (
		<DropdownMenuRadioGroup value={isActive ? "question" : undefined}>
			<DropdownMenuRadioItem
				disabled={disabled}
				onClick={() =>
					editor
						.chain()
						.focus()
						.setQuestion({ options: { type: "one" } })
						.run()
				}
				value="question"
			>
				<div className="flex items-center gap-2">
					<Icon icon="file-question-mark" />
					{t("editor.question.name")}
				</div>
			</DropdownMenuRadioItem>
		</DropdownMenuRadioGroup>
	);
};

export default QuestionMenuButton;
